/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SummarySections_change$ref = any;
export type AlertSeverity = "ERROR" | "INFO" | "SUCCESS" | "WARNING";
import type { FragmentReference } from "relay-runtime";
declare export opaque type Role_change$ref: FragmentReference;
declare export opaque type Role_change$fragmentType: Role_change$ref;
export type Role_change = {|
  +command: string,
  +databaseId: string,
  +id: string,
  +type: string,
  +alerts: $ReadOnlyArray<{|
    +path: ?string,
    +message: string,
    +severity: AlertSeverity,
  |}>,
  +role?: ?{|
    +circlePolicies: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +databaseId: string,
          +displayName: string,
        |}
      |}>
    |},
    +circleRoles: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +databaseId: string,
          +displayName: string,
        |}
      |}>
    |},
    +databaseId: string,
    +name: string,
    +localizedName: string,
    +rawPurpose: ?string,
    +mdPurpose: ?string,
    +isProtected: boolean,
    +supportingCircle: ?{|
      +id: string
    |},
    +circle: ?{|
      +supportedRole: ?{|
        +databaseId: string
      |}
    |},
    +domains: {|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +databaseId: string,
          +rawDescription: string,
          +markdownDescription: string,
          +isProtected: boolean,
        |}
      |}>
    |},
    +accountabilities: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +databaseId: string,
          +rawDescription: string,
          +markdownDescription: string,
          +isProtected: boolean,
        |}
      |}>
    |},
  |},
  +circle?: ?{|
    +databaseId: string,
    +localizedName: string,
    +shortName: string,
    +supportedRole: ?{|
      +databaseId: string
    |},
    +policies: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +databaseId: string,
          +displayName: string,
        |}
      |}>
    |},
    +roles: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +databaseId: string,
          +displayName: string,
          +isProtected: boolean,
        |}
      |}>
    |},
  |},
  +roleHasBeenRemoved?: boolean,
  +organization?: {|
    +isWysiwygEnabled: boolean,
    +isOnV4: boolean,
  |},
  +rolesToMoveDown?: $ReadOnlyArray<{|
    +databaseId: string
  |}>,
  +rolesToMoveUp?: $ReadOnlyArray<{|
    +databaseId: string
  |}>,
  +policiesToMoveDown?: $ReadOnlyArray<{|
    +databaseId: string
  |}>,
  +policiesToMoveUp?: $ReadOnlyArray<{|
    +databaseId: string
  |}>,
  +$fragmentRefs: SummarySections_change$ref,
  +$refType: Role_change$ref,
|};
export type Role_change$data = Role_change;
export type Role_change$key = {
  +$data?: Role_change$data,
  +$fragmentRefs: Role_change$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PolicyEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Policy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": "displayName",
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v3 = {
  "alias": "displayName",
  "args": null,
  "kind": "ScalarField",
  "name": "localizedName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedName",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "RAW"
  }
],
v6 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MARKDOWN"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProtected",
  "storageKey": null
},
v8 = [
  (v0/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "supportedRole",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v11 = [
  (v0/*: any*/),
  {
    "alias": "rawDescription",
    "args": (v5/*: any*/),
    "kind": "ScalarField",
    "name": "description",
    "storageKey": "description(format:\"RAW\")"
  },
  {
    "alias": "markdownDescription",
    "args": (v6/*: any*/),
    "kind": "ScalarField",
    "name": "description",
    "storageKey": "description(format:\"MARKDOWN\")"
  },
  (v7/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Role_change",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "command",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Alert",
      "kind": "LinkedField",
      "name": "alerts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "severity",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PolicyConnection",
              "kind": "LinkedField",
              "name": "circlePolicies",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleConnection",
              "kind": "LinkedField",
              "name": "circleRoles",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoleEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Role",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v3/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": "name",
              "args": null,
              "kind": "ScalarField",
              "name": "localizedName",
              "storageKey": null
            },
            (v4/*: any*/),
            {
              "alias": "rawPurpose",
              "args": (v5/*: any*/),
              "kind": "ScalarField",
              "name": "purpose",
              "storageKey": "purpose(format:\"RAW\")"
            },
            {
              "alias": "mdPurpose",
              "args": (v6/*: any*/),
              "kind": "ScalarField",
              "name": "purpose",
              "storageKey": "purpose(format:\"MARKDOWN\")"
            },
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Circle",
              "kind": "LinkedField",
              "name": "supportingCircle",
              "plural": false,
              "selections": [
                (v1/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Circle",
              "kind": "LinkedField",
              "name": "circle",
              "plural": false,
              "selections": [
                (v9/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v10/*: any*/),
              "concreteType": "DomainConnection",
              "kind": "LinkedField",
              "name": "domains",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DomainEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Domain",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": (v11/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "domains(first:100)"
            },
            {
              "alias": null,
              "args": (v10/*: any*/),
              "concreteType": "AccountabilityConnection",
              "kind": "LinkedField",
              "name": "accountabilities",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccountabilityEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Accountability",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": (v11/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "accountabilities(first:100)"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Circle",
          "kind": "LinkedField",
          "name": "circle",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "shortName",
              "storageKey": null
            },
            (v9/*: any*/),
            {
              "alias": null,
              "args": (v10/*: any*/),
              "concreteType": "PolicyConnection",
              "kind": "LinkedField",
              "name": "policies",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": "policies(first:100)"
            },
            {
              "alias": null,
              "args": (v10/*: any*/),
              "concreteType": "RoleConnection",
              "kind": "LinkedField",
              "name": "roles",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoleEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Role",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v3/*: any*/),
                        (v7/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "roles(first:100)"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roleHasBeenRemoved",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "organization",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isWysiwygEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isOnV4",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "rolesToMoveDown",
          "plural": true,
          "selections": (v8/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "rolesToMoveUp",
          "plural": true,
          "selections": (v8/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Policy",
          "kind": "LinkedField",
          "name": "policiesToMoveDown",
          "plural": true,
          "selections": (v8/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Policy",
          "kind": "LinkedField",
          "name": "policiesToMoveUp",
          "plural": true,
          "selections": (v8/*: any*/),
          "storageKey": null
        }
      ],
      "type": "RoleChange",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SummarySections_change"
    }
  ],
  "type": "DescribeChangeable",
  "abstractKey": "__isDescribeChangeable"
};
})();
// prettier-ignore
(node/*: any*/).hash = '68218cfb9189f6ca937d8fd4b5b1055e';

module.exports = node;
